import { configureStore } from "@reduxjs/toolkit";

// import personalInfoReducer from "./features/register/personalInfo/personalInfoSlice";

import registrationReducer from "./features/registration/registrationSlice";
import loggedInStateReducer from "./features/login/loginSlice";

const store = configureStore({
  reducer: {

    // personalInfo: personalInfoReducer,

    registration: registrationReducer,
    loggedInState: loggedInStateReducer,
  },
});
// console.log("Initial State:", store.getState());
export default store;
